import React, { useState } from 'react';
import { Box, MenuItem, Text, config } from 'folds';
// import { RoleInviteList } from './RoleInviteList';
import { InvitedSelectionAI } from './InvitedSelection'
import robotLogo from '../../../../public/icon/新增機器人按鈕.png';

type InviteSelect = {
  select: string;
  label: string;
  icon: string;
};

export const INVITE_SELECTS: InviteSelect[] = [
  { select: 'AI', label: '客服AI機器人', icon: robotLogo },
];

type InvitedSelectContentProps = {
  roomId: string;
};

export function InvitedSelectContent({ roomId }: InvitedSelectContentProps) {
  const [selectedSelect, setSelectedSelect] = useState<string | null>(null);

  return (
    <Box direction="Column" style={{ padding: config.space.S200 }}>
      {INVITE_SELECTS.map(({ select, label, icon }) => (
        <Box key={select} direction="Column">
          <MenuItem
            size="400"
            radii="300"
            variant="Surface"
            aria-pressed={selectedSelect === select}
            onClick={() => setSelectedSelect(selectedSelect === select ? null : select)}
            before={
              <img src={icon} style={{ width: '24px', height: '24px' }} alt={label} />
            }
          >
            <Text size="T300" style={{ fontWeight: 500 }}>{label}</Text>
          </MenuItem>
          {selectedSelect === select && (
            <Box style={{ paddingLeft: config.space.S400, paddingBottom: config.space.S100 }}>
              <InvitedSelectionAI sroomid={roomId} />
            </Box>
          )}
        </Box>
      ))}
    </Box>
  );
}
